<template>
    <div class="traffic">
        <servicesList></servicesList>
        <div class="traffic_content">
            <ul class="category_lists">
                <li v-for='(n,i) in traffic_lists' :key="i" @click="traffic(i)"
                    :class="{ category_active:traffic_index === i}">{{$t(n)}}
                </li>
            </ul>
            <carTraffic v-if="traffic_index === 0" :busTraffic_route='traffic_content'></carTraffic>
            <busTraffic v-else :busTraffic_route='traffic_content' :type="traffic_index"></busTraffic>
           <!-- <lightRailTraffic v-else-if="traffic_index === 2"
                              :busTraffic_route='traffic_content'></lightRailTraffic>-->
        </div>
    </div>
</template>
<script>
    import busTraffic from '../../components/services/busTraffic';
    import carTraffic from '../../components/services/carTraffic';
    import lightRailTraffic from '../../components/services/lightRailTraffic';
    import servicesList from '../../components/services/servicesList';

    export default {
        name: "traffic",
        data: function () {
            return {
                traffic_lists: ['traffic_type[0]', 'traffic_type[1]', 'traffic_type[2]', 'traffic_type[3]'],
                traffic_index: 0,
                traffic_content: ''
            }
        },
        components: {
            busTraffic,
            carTraffic,
            lightRailTraffic,
            servicesList
        },
        created: function () {
            this.traffic(0);
            this.$store.commit("set_current_index", 0);
            this.$store.commit("set_current", 5);
            this.$store.commit("set_title", 'nav.service');
        },
        methods: {
            traffic: function (i) {
                this.traffic_index = i;
                console.log(typeof i);
                let n = 0;
                if (i === 0) {
                     n = 2;
                }else {
                    n = i + 1;
                }
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/serve/getTraffic",
                    dataType: "json",
                    data: {
                        traffic_id: n,
                        lang: window.$lang
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            this.traffic_content = res.data.result;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });


            }
        },
        computed: {
            service_list: function () {
                return this.$store.state.service.service_list;
            },
            weburl: function () {
                return this.$store.state.weburl;

            }
        },

    }
</script>

<style scoped lang="less">
    @import '../../assets/less/categoryLists';
    @import "../../assets/less/direction.less";

    .traffic_content {
        .padding;
        padding: 10px 20px;
        .media;
    }

</style>
